import { Paper, ScrollArea, Button, ThemeIcon, Center, Loader, useMantineTheme, Stack, Text } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { IconAlertTriangle, IconBolt, IconClipboard, IconFileCheck, IconFilePencil, IconRepeat, IconShield, IconSnowflake, IconTag, IconTool, IconTrash } from "@tabler/icons-react";
import cx from "clsx";

import { ListCategoryDto } from "../../models/categories.models";
import { useFilteredCategories } from "../../functions/category-filter.hooks";
import { useSearch } from "../../functions/SearchBox.hook";
import { NoSearchResults } from "../Shared/NoSearchResults";
import classes from './CategoryList.module.css';

interface CategoriesListProps {
	categories?: ListCategoryDto[] | undefined;
	isLoading?: boolean;
	selectedCategory?: ListCategoryDto | null;
	setSelectedCategory?: (category: ListCategoryDto | null) => void;
}
export const CategoriesList = ({ categories, selectedCategory, setSelectedCategory, isLoading }: CategoriesListProps) => {
	const theme = useMantineTheme();
	const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`, true);
	const { query, setQuery } = useSearch();
	const { filteredCategories, showNoResults } = useFilteredCategories(categories || []);

	const iconMap = {
		"icon-tag": <IconTag />,
		"icon-exclamation": <IconAlertTriangle />,
		"icon-bolt": <IconBolt />,
		"icon-clipboard": <IconClipboard />,
		"icon-tool": <IconTool />,
		"icon-repeat": <IconRepeat />,
		"icon-file-pencel": <IconFilePencil />,
		"icon-snowflake": <IconSnowflake />,
		"icon-shield": <IconShield />,
		"icon-file-check": <IconFileCheck />
	}

	// useEffect(() => {
	// 	if (categoryIdFromParams) {
	// 		const category = categories?.find(cat => cat.CategoryId === categoryIdFromParams);
	// 		if (category) {
	// 			setSelectedCategory?.(category);
	// 		}
	// 	} else if (categories && categories.length > 0) {
	// 		setSelectedCategory?.(categories[0]);
	// 		// history.push(`/categories/${categories[0].CategoryId}`);
	// 	}

	// }, [categoryIdFromParams, categories]);

	if (isLoading) return <Paper withBorder p={0} radius="md" style={{ overflow: 'hidden' }}>
			<ScrollArea type={isMobile ? "never" : "scroll"} style={{ height: isMobile ? 'unset' : 'calc(100vh - 160px)', minHeight: isMobile ? 'calc(100vh - 150px)' : 'calc(100vh - 160px)' }} >
				<Center>
					<Loader size="sm" mt="lg" />
				</Center>
			</ScrollArea>
		</Paper>

	const handleCategorySelect = (e: React.MouseEvent<HTMLAnchorElement>, category: ListCategoryDto): void => {
		e.preventDefault();
		setSelectedCategory?.(category);
		// history.push(`/categories/${category.CategoryId}`);
	}

	return <>
		<Paper withBorder p={0} radius="md" style={{ overflow: 'hidden' }}>
			<ScrollArea type={isMobile ? "never" : "hover"} style={{ height: isMobile ? 'unset' : 'calc(100vh - 160px)', minHeight: isMobile ? 'calc(100vh - 150px)' : 'calc(100vh - 160px)' }} >	
				{filteredCategories?.map(category => (
					<Button key={category.CategoryId}
						component="a"
						href={`/categories/${category.CategoryId}`}
						onClick={(e) => handleCategorySelect(e, category)}
						className={cx(classes['category-list-item'], { [classes['selected-item']]: selectedCategory?.CategoryId === category.CategoryId })}
						leftSection={
							<ThemeIcon radius="xl" 
								color={category.Deleted ? "red" : category.Color} 
								size="xl" 
								style={{ border: `1px solid var(--mantine-color-default-border)` }}
								variant="light"
							>
								{!category.Deleted ? (iconMap[category.Icon as keyof typeof iconMap] || <IconTag size={24} />) : <IconTrash size={24} />}
							</ThemeIcon>
						}
					>
						<Text c={category.Deleted ? "dimmed" : ""}>{category.Title}</Text>
					</Button>
				))}
				{showNoResults && <NoSearchResults searchType="categories" query={query} setQuery={setQuery} />}
				{categories?.length === 0 && <>
					<Stack align="center" justify="center" mt="xl" px="sm">
						<ThemeIcon size={100} radius={100} variant="light" color="gray">
							<IconTag size={60} />
						</ThemeIcon>
						<Text style={{ textAlign: 'center' }} lineClamp={1} c="dimmed">No categories have been created yet.</Text>
					</Stack>
				</>}
			</ScrollArea>
		</Paper>
	</>
}